import * as React from 'react';
import { DropdownPopover, Outside, UIText2 } from '@cian/ui-kit';
import { IconSort16 } from '@cian/ui-kit/icons';
import * as styles from './SortingDesktop.css';
import { ISortingProps } from '../../types';

import { SortingDesktopDropdown } from '../SortingDesktopDropdown';

export const SortingDesktop: React.FC<ISortingProps> = ({
  disabled,
  onChange,
  options,
  placeholder,
  selectedOption,
}) => {
  const [isOpenDropdown, setIsOpenDropdown] = React.useState(false);

  const dropdownRef = React.useRef<HTMLUListElement>(null);
  const buttonRef = React.useRef<HTMLButtonElement>(null);

  const openDropdown = React.useCallback(() => {
    setIsOpenDropdown(true);
  }, []);

  const closeDropdown = React.useCallback(() => {
    setIsOpenDropdown(false);

    if (buttonRef.current) {
      buttonRef.current.focus();
    }
  }, []);

  return (
    <Outside onOutside={closeDropdown} active={isOpenDropdown} insideRefs={[dropdownRef]}>
      <div>
        <DropdownPopover
          open={isOpenDropdown}
          content={
            <SortingDesktopDropdown
              dropdownRef={dropdownRef}
              onChange={onChange}
              onClose={closeDropdown}
              selectedOption={selectedOption}
              options={options}
            />
          }
        >
          <button
            ref={buttonRef}
            className={styles['sort-button']}
            onClick={isOpenDropdown ? closeDropdown : openDropdown}
            disabled={disabled}
            type="button"
            aria-label="Сортировка"
            aria-haspopup="listbox"
          >
            <span className={styles['sort-icon']}>
              <IconSort16 color="current_color" />
            </span>
            <UIText2 color="current_color">{selectedOption ? selectedOption.label : placeholder}</UIText2>
          </button>
        </DropdownPopover>
      </div>
    </Outside>
  );
};
